export default __webpack_public_path__ + "static/media/logo-white-with-sub.e4d5e26b.svg";